<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <v-row>
                            <v-col cols="12" md="12">
                                <h4>Pendientes de Pago</h4>
                            </v-col>
                        </v-row>
                        <div class="mt-1" style="height: 450px; overflow-y: scroll;" >
                            <v-card rounded="xl" style="background-color: beige;" flat class="mt-1"
                                v-for="item in myPagos" :key="item.Profesional">
                                <v-container>
                                    <v-row>
                                        <v-col cols="5" md="7">
                                            <h5>{{ item.Nombre }}</h5>
                                        </v-col>
                                        <v-col cols="5" md="3">
                                            <h4 class="ml-n1 red--text">$ {{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Total)) }}</h4>
                                        </v-col>
                                        <v-col cols="2" md="2">
                                            <v-icon @click="search_detail_payment(item)" class="ml-2">play_arrow</v-icon>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </div>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-sheet style="border:1px solid lightgray" width="100%" rounded="xl">
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <h4>Servicios pendientes de pago</h4>
                                            </v-col>
                                            <v-col cols="12" md="6" class="text-end">
                                                <v-icon class="mt-n1">person</v-icon>
                                                <strong class="ml-2 brown--text">{{ txt_profesional }}</strong>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-sheet>
                            </v-col>
                            <v-col cols="12" md="12" class="mt-n2">
                                <v-simple-table fixed-header dense height="290" style="border:1px solid lightgray" class="text-size">
                                    <thead>
                                        <tr>
                                            <th style="background-color: lightgrey;width: 15%;">Fecha</th>
                                            <th style="background-color: lightgrey;width: 12%;">Comanda</th>
                                            <th style="background-color: lightgrey;width: 25%;">Servicio</th>
                                            <!-- <th style="background-color: lightgrey;width: 25%;">Detalle</th> -->
                                            <th style="background-color: lightgrey;width: 15%;">Total</th>
                                            <th style="background-color: lightgrey;width: 8%;">Pagar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in detailPagos" :key="item.Comanda">
                                            <td><span>{{ item.Fecha }}</span></td>
                                            <td><span>{{ item.Comanda }}</span></td>
                                            <td><span>{{ item.Servicio }}</span></td>
                                            <!-- <td><span>{{ item.Detalle }}</span></td> -->
                                            <td><span>{{ new Intl.NumberFormat("de-DE").format(parseFloat(item.Ingreso_Local)) }}</span></td>
                                            <td>
                                                <v-icon class="ml-2" v-if="item.Estado!='V'" @click="ck_push(item)" color='green'>check_box_outline_blank</v-icon>
                                                <v-icon class="ml-2" v-else @click="ck_push(item)" color='green'>check_box</v-icon>
                                            </td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-col>
                            <v-col cols="12" md="12">
                                <v-row>
                                    <v-col cols="12" md="8" class="mt-2 d-flex">
                                        <h4>RECAUDACIÓN:</h4>
                                        <h2 class="ml-2 mt-n2 teal--text">$ {{ new Intl.NumberFormat("de-DE").format(parseFloat(recauda)) }}</h2>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-select class='text-caption' v-model="forma" :items="myFormaPago" label="Forma de Pago" item-text="name" item-value="name" dense outlined rounded></v-select>
                                    </v-col>
                                </v-row>                                    
                                <v-row class="mt-n7">                                    
                                    <v-col cols="12" md="8">
                                        <v-text-field label="Observación" class='text-body-2' v-model="observa" dense outlined rounded></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-btn @click="save_pago()" class="mt-1" color="teal" small rounded block dark>Pagar</v-btn>                                    
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div style="height: 50px;"></div>
        <v-footer height="50" color="#c1680e" fixed></v-footer>

        <img id="logo_solarium" src="@/assets/logo_solarium.jpg" height="0" width="0">             

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 20px !important;
    /* background-color: lightyellow; */
}
</style>
<script>
import axios from "axios";
import { jsPDF } from "jspdf";
export default {
    name: 'Pagos',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,
        forma:null,
        myFormaPago:[],
        observa:'',
        myPagos:[],
        detailPagos:[],
        myLista:[],
        myEmisor:[],
        txt_profesional:'',
        recauda:0,


    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(3);
            if(parseInt(this.bloqueo)!=0){
                await this.search_formas();
                await this.search_pyment();
            }
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async search_emisor(){
            this.myEmisor=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/search/emisor/',params,{headers});
                const datos = res.data;
                console.log('emisor',datos);
                if(datos[0].existe=='si'){
                    var img = document.getElementById("logo_solarium");
                    img.src=datos[0].Logo;
                    this.myEmisor=datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_formas(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'forma' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/type/payments/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.myFormaPago.push({
                            'name': element.Forma,
                            'comis': element.Comision
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_pyment(){
            this.myPagos=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/payments/',params,{headers});
                const datos = res.data;
                console.log('Pagos pendientes',datos);
                if(datos[0].existe=='si'){
                    this.myPagos = datos; 
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_detail_payment(item){
            this.detailPagos=[];
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'profesional': item.Profesional
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/detail/payment/',params,{headers});
                const datos = res.data;
                console.log('Pagos pendientes',datos);
                if(datos[0].existe=='si'){
                    this.txt_profesional = item.Nombre;
                    datos.forEach(element => {
                        this.detailPagos.push({
                            "Profesional":element.Profesional,
                            "Comanda":element.Comanda,
                            "Detalle": element.Detalle,
                            "Fecha": element.Fecha,
                            "Ingreso_Local": element.Ingreso_Local,
                            "Servicio": element.Servicio,
                            "Total_Servicio": element.Total_Servicio,
                            "Estado": "N"
                        })
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async ck_push(fila){
            console.log('fila',fila);
            if(fila.Estado=='N'){
                fila.Estado='V';
                this.recauda=parseFloat(this.recauda) + parseFloat(fila.Ingreso_Local);
            } else {
                fila.Estado='N'
                this.recauda=parseFloat(this.recauda) - parseFloat(fila.Ingreso_Local);
            };
            console.log(fila.Estado);
        },
        async save_pago(){
            this.loading=true;
            if(parseFloat(this.recauda)!=0){
                let save='no';
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    //recorremos el detalle de los pagos
                    for (let index = 0; index < this.detailPagos.length; index++) {
                        const element = this.detailPagos[index];
                        if(element.Estado=='V'){
                            const params = {
                                'contrato' : this.contrato,
                                'user' : this.user,
                                'profesional': element.Profesional,
                                'comanda': element.Comanda,
                                'total': element.Ingreso_Local,
                                'forma': this.forma,
                                'observa': this.observa
                            }
                            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/payment/',params,{headers});
                            const datos = res.data;
                            console.log('params', params)
                            if(datos[0].existe=='si'){
                                save='si';
                            }
                        }
                    }
                    if(save=='si'){
                        //eliminamos los registros pagados de la lista
                        let temp_pagos=[];
                        this.detailPagos.forEach(element => {
                            if(element.Estado!='V'){
                                temp_pagos.push(element)
                            }
                        });
                        //reemplazamos la lista
                        this.detailPagos = temp_pagos;
                        //descontamos la recaudacion al total
                        const found = this.myPagos.filter(res=> res.Nombre == this.txt_profesional);
                        if(found.length!=0){
                            const deuda = parseFloat(found[0].Total) - parseFloat(this.recauda);
                            found[0].Total = deuda
                        };
                        this.forma=null;
                        this.observa='';
                        this.recauda=0;
                        this.color_snack='success';
                        this.mensaje='Recaudación ingresada con exito';
                        this.snack=true;
                    } else {
                        this.color_snack='error';
                        this.mensaje='Recaudación no ingresado';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                    this.color_snack='error';
                    this.mensaje='Error, informar a soporte';
                    this.snack=true
                }   
            } else {
                this.color_snack='error';
                this.mensaje='No existe recaudación';
                this.snack=true
            }
            this.loading=false;
        },

        async PDF_caja(){
            this.loading=true;

            const head_venta = this.myLista;
            console.log('data_PDF',head_venta)

            const doc = new jsPDF('p', 'mm', 'letter');

            var img_fondo = document.getElementById("logo_solarium");
            doc.addImage(img_fondo, 'JPEG', 15, 15, 75, 20)

            //grosor linea
            doc.setLineWidth(0.2);
            //horizontal lines
            doc.line(10, 10, 120, 10);
            doc.line(10, 40, 120, 40);
            //vertical lines
            doc.line(10, 9.5, 10, 40.5);
            doc.line(120, 9.5, 120, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(14);
            doc.text('FLUJO DE CAJA', 145, 15);

            doc.line(130, 30, 200, 30);
            doc.line(130, 40, 200, 40);
            //vertical lines
            doc.line(130, 30.5, 130, 40.5);
            doc.line(200, 30.5, 200, 40.5);

            doc.setFont("arial", "bold");
            doc.setFontSize(10);
            doc.text('FECHA : ', 135, 36);
            doc.setFontSize(12);
            doc.text('' + this.date1, 170, 36);


            //obtener datos del usuario
            doc.setFontSize(8);
            let line = 45;
            doc.line(10, line, 200, line);
            line = line + 5;
            doc.text('TOTALES', 15, line);
            this.myTotales.forEach(element => {
                line = line + 5;
                doc.setFont("arial", "bold");
                doc.text('' + element.forma, 15, line);
                doc.setFont("arial", "normal");
                doc.text('Venta : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total_servicio)), 45, line);
                doc.text('Ingreso : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total_ingreso)), 75, line);
                doc.text('Egreso : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total_egreso)), 105, line);
                doc.text('Total : $ ' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total)), 135, line);
            });
            line = line + 5;
            doc.line(10, line, 200, line);

            line = line + 3.5;
            doc.setFont("arial", "bold");
            doc.text('SERVICIO', 10, line);
            doc.text('DETALLE', 30, line);
            doc.text('PROFESIONAL', 135, line);
            doc.text('TOTAL', 170, line, { align: "right" });
            doc.text('I/E', 190, line);
            
            line = line + 1.5;
            doc.line(10, line, 200, line);
            
            //Detalle
            line = line + 5;
            doc.setFont("arial", "normal");
            this.myLista.forEach(element => {
                doc.text('' + element.servicio, 10, line);
                doc.text('' + element.detalle, 30, line);
                doc.text('' + element.profesional, 135, line);
                doc.text('' + new Intl.NumberFormat("de-DE").format(parseFloat(element.total)), 170, line, { align: "right" });
                doc.text('' + element.tipo, 190, line);                            
                line = line + 5;
            });
           
            doc.output('dataurlnewwindow')
            this.loading=false;
        },


    }
}
</script>